var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 139,
    viewBox: "0 0 418 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_1520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.2547 92L44.4907 92L44.4907 138.745L-2.25471 138.745L-2.2547 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.815 138.746L184.561 138.746L184.561 185.491L137.815 185.491L137.815 138.746Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.885 92L324.63 92L324.63 138.745L277.885 138.745L277.885 92Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4908 92L91.2362 92L91.2362 138.745L44.4908 138.745L44.4908 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.2547 138.746L44.4907 138.746L44.4907 185.491L-2.25471 185.491L-2.2547 138.746Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.21 92L417.955 92L417.955 138.745L371.21 138.745L371.21 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.815 92L184.561 92L184.561 138.745L137.815 138.745L137.815 92Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.394 92L231.14 92L231.14 138.745L184.394 138.745L184.394 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.464 92L371.21 92L371.21 138.745L324.464 138.745L324.464 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14 92L277.885 92L277.885 138.745L231.14 138.745L231.14 92Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0698 92L137.815 92L137.815 138.745L91.0698 138.745L91.0698 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0696 138.745L137.815 138.745L137.815 185.49L91.0696 185.49L91.0696 138.745Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.639 103.751L406.284 92.1062L417.929 103.751L406.284 115.397L394.639 103.751Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.334 103.714L382.979 92.0684L394.624 103.714L382.979 115.359L371.334 103.714Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.601 127.056L406.246 115.411L417.891 127.056L406.246 138.701L394.601 127.056Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.296 127.019L382.941 115.374L394.587 127.019L382.941 138.664L371.296 127.019Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.275 92L324.631 103.645L324.631 92L336.275 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.92 92L359.565 92L324.63 126.934L324.63 115.289L347.92 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.21 92L324.631 138.745L336.275 138.745L371.21 103.645L371.21 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.209 115.29L347.92 138.745L359.565 138.745L371.209 126.934L371.209 115.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14 126.935L242.951 138.746L231.14 138.746L231.14 126.935Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14 115.29L231.14 103.645L266.24 138.745L254.595 138.745L231.14 115.29Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.14 92L277.885 138.745L277.885 126.934L242.951 92L231.14 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.596 92L277.885 115.29L277.885 103.645L266.24 92L254.596 92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.815 115.29L137.815 138.579L161.105 138.579C161.271 125.77 150.791 115.29 137.815 115.29Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.526 138.745L137.815 138.745L137.815 115.29C125.006 115.29 114.526 125.77 114.526 138.745Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.815 162.035L137.815 138.745L114.526 138.745C114.526 151.554 125.006 162.035 137.815 162.035Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.271 138.746L137.981 138.746L137.981 162.035C150.791 162.035 161.271 151.555 161.271 138.746Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1355 103.645L79.425 103.645L79.425 126.934L56.1355 126.934L56.1355 103.645Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55642 103.645L32.8459 103.645L32.8459 126.934L9.55641 126.934L9.55642 103.645Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4907 162.035L21.2012 138.746L-2.25471 162.035L44.4907 162.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.21 138.563L371.21 185.309L324.464 185.309L324.464 138.563L371.21 138.563Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.525 138.669L324.525 185.414L277.78 185.414L277.78 138.669L324.525 138.669Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.84 138.608L277.84 185.354L231.095 185.354L231.095 138.608L277.84 138.608Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.631 138.746L324.631 185.491L277.885 185.491C277.885 159.54 298.846 138.746 324.631 138.746Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.918 138.736L371.208 162.027L347.918 185.317L324.627 162.027L347.918 138.736Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.885 185.325L254.596 162.035L277.885 138.746L277.885 185.325Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 92.7459L44 46.0005L90.7448 46.0005L90.7448 92.7459L44 92.7459Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6841 92.8518L90.6841 46.1064L137.429 46.1065L137.429 92.8518L90.6841 92.8518Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.368 92.7908L137.368 46.0454L184.113 46.0454L184.113 92.7908L137.368 92.7908Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.661 92.6858L137.306 81.041L137.306 92.6858L125.661 92.6858Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.017 92.6857L102.372 92.6857L137.306 57.7515L137.306 69.3962L114.017 92.6857Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7275 92.6854L137.306 46.1064L125.661 46.1064L90.7275 81.0407L90.7275 92.6854Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7275 69.3959L114.017 46.1064L102.372 46.1064L90.7275 57.7512L90.7275 69.3959Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3187 92.749L44.0286 69.4585L67.3187 46.168L90.6089 69.4585L67.3187 92.749Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05 46.1074L160.761 69.3969L184.05 92.6864L184.05 46.1074Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.11 46.0002L418.11 92.7456L371.365 92.7456L371.365 46.0002L418.11 46.0002Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.426 46.1055L371.426 92.8508L324.681 92.8508L324.681 46.1055L371.426 46.1055Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.742 46.0449L324.742 92.7903L277.997 92.7903L277.997 46.0449L324.742 46.0449Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.532 46.1824L371.532 92.9277L324.787 92.9277C324.787 66.9766 345.747 46.1824 371.532 46.1824Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.532 57.8269L371.532 92.7612L336.598 92.7612C336.431 73.4641 352.068 57.8269 371.532 57.8269Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.819 46.1732L418.109 69.4636L394.819 92.7541L371.528 69.4636L394.819 46.1732Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.787 92.7614L301.498 69.4719L324.787 46.1824L324.787 92.7614Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.428 46.0002L231.428 92.7456L184.683 92.7456L184.683 46.0002L231.428 46.0002Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.112 46.061L278.112 92.8064L231.367 92.8064L231.367 46.061L278.112 46.061Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.778 81.1772C248.347 81.1772 243.133 75.9637 243.133 69.5324C243.133 63.1012 248.347 57.8877 254.778 57.8877C261.209 57.8877 266.422 63.1012 266.422 69.5324C266.422 75.9637 261.209 81.1772 254.778 81.1772Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.033 57.7212C201.545 57.7212 196.388 62.8781 196.388 69.3659C196.388 75.8537 201.545 81.0107 208.033 81.0107C214.521 81.0107 219.678 75.8537 219.678 69.3659C219.678 63.0445 214.521 57.7212 208.033 57.7212Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 46.7461L277 0.000732422L323.745 0.000740595L323.745 46.7461L277 46.7461Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.684 46.8521L323.684 0.106689L370.429 0.106698L370.429 46.8521L323.684 46.8521Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.368 46.791L370.368 0.0456543L417.113 0.0456625L417.113 46.791L370.368 46.791Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.661 46.686L370.306 35.0413L370.306 46.686L358.661 46.686Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.017 46.686L335.372 46.686L370.306 11.7517L370.306 23.3965L347.017 46.686Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.727 46.6857L370.306 0.106689L358.661 0.106687L323.727 35.0409L323.727 46.6857Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.727 23.3962L347.016 0.106689L335.372 0.106687L323.727 11.7514L323.727 23.3962Z",
    fill: "#D62340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.319 46.7492L277.028 23.4587L300.319 0.168272L323.609 23.4587L300.319 46.7492Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.05 0.107666L393.761 23.3972L417.05 46.6867L417.05 0.107666Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.428 0.000476837L464.428 46.7458L417.683 46.7458L417.683 0.000468664L464.428 0.000476837Z",
    fill: "#D62340"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_1520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 139,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.63dc7576dcabfff21fd21b3a1a3f3878.svg";
export { ForwardRef as ReactComponent };